/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const IS_LOADING = 'IS_LOADING';
export const REFRESH_TOTAL_DOLLER_PAID = 'REFRESH_TOTAL_DOLLER_PAID';
export const SET_TOTAL_DOLLER_PAID_REPORT = 'GET_TOTAL_DOLLER_PAID_REPORT';
export const CHECK_NUMBER_TDP = 'CHECK_NUMBER_TDP';
export const ERROR_LIST_TDP = 'ERROR_LIST_TDP';
